import { Sparkles } from "lucide-react";
import { useHotkeys } from "react-hotkeys-hook";
import { Button } from "@/components/ui/button";
import { useAssistantDock } from "./store";
import { useAssistantStatus } from "./hooks";

// Lançador do assistente no Topbar + hotkey mod+j (mod+k é do palette). Oculto
// quando a feature está desligada. O hook roda incondicional (antes do return) — a hotkey só age
// quando habilitada.
export function AssistantLauncher() {
  const open = useAssistantDock((s) => s.open);
  const toggle = useAssistantDock((s) => s.toggleOpen);
  const enabled = useAssistantStatus().data?.enabled ?? false;

  useHotkeys(
    "mod+j",
    (e) => {
      e.preventDefault();
      if (enabled) toggle();
    },
    { enableOnFormTags: true }
  );

  if (!enabled) return null;
  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label="Abrir assistente"
      aria-pressed={open}
      onClick={() => toggle()}
    >
      <Sparkles className="h-4 w-4" />
    </Button>
  );
}
